import React, {useState, useEffect} from 'react'
import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { BsFacebook } from 'react-icons/bs'
import { FcGoogle } from 'react-icons/fc'
import { generateFacebook_link } from '../helpers/facebook_link_cleaner'
import { linguaT } from "../helpers/linguaT";
import Done from './Done'

function LeaveReview(props) {
  const { facebook_link, facebook_id, google, lang } = props;
  const style = {
    root: {
      display: "flex",
      flexDirection: "column",
      margin: "auto",
      width: "100%",
      maxWidth: "300px",
    },
    text: {
      my: 2
    },
    button:{
      textTransform: "none",
      my: 1
    },
    button_text: {
      ml:1
    }
  }

  const [googleButton, setGoogleButton] = useState(false)
  const [facebookButton, setFacebookButton] = useState(false)
  const [facebookGeneratedLink, setFacebookGeneratedLink] = useState('')
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    if(google.length > 0){
      setGoogleButton(true);
    }
  
    if(facebook_link.length > 0 || facebook_id.length > 0){
      setFacebookButton(true);
      setFacebookGeneratedLink(
        generateFacebook_link(facebook_id, facebook_link)
      );
    }

    if(google.length === 0 && facebook_id.length === 0 && facebook_link.length === 0){
      setShowButtons(false)
    }else{
      setShowButtons(true)
    }
    
  }, [google, facebook_id, facebook_link]);

  const goto = (link) => { window.location.href = link }

  const googleFacebookJSX = () =>{
    return (
      <>
        <Button 
          sx={style.button}
          variant="contained"
          onClick={()=>goto(facebookGeneratedLink)}
        >
          <BsFacebook size={20} />
          <Typography 
            variant='subtitle1'
            sx={style.button_text}
          >
            Facebook
          </Typography>
        </Button>
      </>
    )
    
  }
  const googleButtonJSX = () =>{
    return (
      <>
        <Button 
          sx={style.button} 
          variant="outlined"
          onClick={()=>goto(google)}>
            <FcGoogle size={22} />
            <Typography 
              variant='subtitle1'
              sx={style.button_text}
            >
              Google
            </Typography>
        </Button>
      </>
    )
    
  }


  return(
    <>
      { showButtons ? 
        <Box sx={style.root}>
          <Typography 
            variant='subtitle1'
            sx={style.text}
          >
            { linguaT("where_LeaveReview", lang, []) }
          </Typography>
          
          { googleButton && googleButtonJSX() }
          { facebookButton && googleFacebookJSX() }

        </Box>
        :
        <Done lang={lang} />  
      }
    </>
  )
  
}

export default LeaveReview